// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1uFQw","additionalInfo":"AgreementModal_additionalInfo__3qEDo"};